
//Représente la sélection de la grille pour le calcul ou l’envoi des statuts à envoyer (SU #119400)
//  La liste ne peut pas être vide : la route la refuse, et le menu est grisé sans sélection.
export class AeFSelectionStatutsAEnvoyerFacturesAchatParametres
{
  //Identifiants des factures sélectionnées dans la grille
  public identifiantsFactures!: string[];
}

//Représente le résultat du calcul des statuts à envoyer (SU #119400)
export class AeFMarquerStatutsFacturesAchatResultat
{
  //Création
  constructor ()
  {
    this.nombreFacturesExaminees = 0;
    this.nombreFacturesMarquees = 0;
    this.nombreFacturesMarqueesParStatut = {};
    this.nombreFacturesBloqueesMotifNonType = 0;
  }

  //Nombre de factures candidates examinées
  public nombreFacturesExaminees: number;

  //Nombre de factures marquées d’un statut à envoyer
  public nombreFacturesMarquees: number;

  //Nombre de factures marquées, par code de statut
  public nombreFacturesMarqueesParStatut: Record<string, number>;

  //Nombre de factures laissées en l’état : bloquées sur un motif sans type Litige / Suspension paramétré
  public nombreFacturesBloqueesMotifNonType: number;
}

//Représente le résultat de l’envoi des statuts à la plateforme agréée (SU #119400)
export class AeFEnvoyerStatutsFacturesAchatResultat
{
  //Création
  constructor ()
  {
    this.nombreFacturesEcartees = 0;
    this.nombreFacturesSoumises = 0;
    this.nombreFacturesAcquittees = 0;
  }

  //Nombre de factures dont le statut en attente a été effacé sans être transmis : statut courant changé depuis le calcul
  public nombreFacturesEcartees: number;

  //Nombre de factures dont le statut a été soumis à la plateforme agréée
  public nombreFacturesSoumises: number;

  //Nombre de factures dont la transmission est tracée, sorties de l’onglet « Statuts à envoyer »
  public nombreFacturesAcquittees: number;
}
